import React, { useState } from 'react'
import Topnavbar from '../nav/Topnavbar'
import SideNavbar from '../nav/SideNavbar'
import Box from '@mui/material/Box';

const MainLayout = ({isNewchatbtn,newChatStart,isfatching,filteredToday,messageClick,handleDeletePopup,filteredyesteday,filteredLastweek,filteredLastMonth}) => {

  return (
    <Box>
        <SideNavbar
         isNewchatbtn={isNewchatbtn}
         newChatStart={newChatStart}
         isfatching={isfatching}
         filteredToday={filteredToday}
         messageClick={messageClick}
         handleDeletePopup={handleDeletePopup}
         filteredyesteday={filteredyesteday}
         filteredLastweek={filteredLastweek}
         filteredLastMonth={filteredLastMonth}
        />
    </Box>
  )
}

export default MainLayout
